module.exports = __webpack_public_path__ + "img/tab-login-brand.14df63b4.svg";